<homey-page-title-layout>Mathias & Inês’ story</homey-page-title-layout>
<div class="flex flex-col justify-center items-center pt-4">
  <img class="rounded-full size-32" src="/assets/landing-page/reviews/mathias.webp" alt="">
  <p class="quote mt-4 max-w-sm text-center">“We got selected after only 4 months. It couldn’t have been easier.”</p>
  <p>- Mathias & Inês, Brooklyn</p>
</div>

<div class="space-y-8 mt-16">
  <p>Mathias and Inês both work full-time, and like many couples in Brooklyn, they loved the city, but the cost of living was always in the background. Rent kept climbing, and the idea of finding something affordable felt unrealistic.</p>
  <p>They had looked into the NYC Housing Lottery before, but applying to building after building felt exhausting. With two schedules to manage, the paperwork and deadlines seemed too much to keep up with.</p>
  <p class="quote">“It always felt like something we’d try later, when we had more time.” — Inês</p>
  <p>Then they found Homey.</p>
  <p>They created their profile, and Homey started automatically applying them to every building they were eligible for. No stress. No weekly reminders. No anxiety about missing an important email.</p>
  <p>A few months later, they got the news:</p>
  <p class="quote">“We got selected after a few months — honestly didn’t expect it.” — Mathias</p>
  <p>For Mathias & Inês, getting selected meant more than just lower rent: it meant stability. It meant being able to stay in the city they love, together, without constantly worrying about affording it.</p>
</div>

<div class="flex justify-center mt-8">
  <homey-signup-button signupText="Claim your free trial"/>
</div>
